import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";

export const TrackingForm = ({ size = "hero", initial = "", testPrefix = "hero" }) => {
  const [code, setCode] = useState(initial);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const big = size === "hero";

  const submit = (e) => {
    e.preventDefault();
    const clean = code.toUpperCase().replace(/[^A-Z0-9-]/g, "");
    if (!clean) {
      setError("Inserisci il codice di tracciamento");
      return;
    }
    if (!/^LGT(\d{8,}|\d{4}-\d{6})$/.test(clean)) {
      setError("Formato non valido. Esempio: LGT47563846");
      return;
    }
    setError("");
    navigate(`/traccia/${clean}`);
  };

  return (
    <form onSubmit={submit} className="w-full" data-testid={`${testPrefix}-tracking-form`}>
      <div className={`track-glow flex flex-col sm:flex-row bg-white/[0.06] backdrop-blur-xl border border-white/15 transition-shadow duration-300 ${big ? "p-2" : "p-1.5"}`}>
        <div className="flex items-center flex-1 min-w-0">
          <Search className={`text-slate-400 shrink-0 ${big ? "h-6 w-6 ml-4" : "h-5 w-5 ml-3"}`} />
          <input
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="LGT37559034"
            aria-label="Codice di tracciamento"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="characters"
            spellCheck={false}
            className={`flex-1 min-w-0 bg-transparent outline-none text-white placeholder:text-slate-500 font-mono font-bold tracking-wider ${big ? "px-4 py-4 sm:py-5 text-lg sm:text-2xl" : "px-3 py-3 text-base sm:text-lg"}`}
            data-testid={`${testPrefix}-tracking-input`}
          />
        </div>
        <button
          type="submit"
          className={`group inline-flex items-center justify-center gap-3 bg-[#E50914] hover:bg-[#C10710] active:scale-[0.98] text-white font-display font-bold uppercase tracking-[0.12em] transition-[background-color,transform] duration-200 ${big ? "px-8 py-4 sm:py-5 text-lg sm:text-xl" : "px-6 py-3 text-base"}`}
          data-testid={`${testPrefix}-track-btn`}
        >
          Traccia spedizione
          <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
        </button>
      </div>
      {error && <p className="mt-3 text-sm text-red-400 font-medium" data-testid={`${testPrefix}-tracking-error`}>{error}</p>}
    </form>
  );
};
